// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinkedinOutlinedSvg from "@ant-design/icons-svg/es/asn/LinkedinOutlined";
import AntdIcon from '../components/AntdIcon';

var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinOutlinedSvg
  }));
};

LinkedinOutlined.displayName = 'LinkedinOutlined';
export default React.forwardRef(LinkedinOutlined);